import $axios from './index'

// 获取777数据
// 设备列表
export function getDeviceList(params) {
    const url = '/api/bi/data_statistics/get_777_device_list'
    return $axios.get(url, params)
}

// 获取所有景区列表
export function getStoreList(params) {
    // return $axios.get('/data/queryStoreList', params);
    return $axios.get('/api/bi/data_statistics/get_777_store_list', params);
}
// 获取数据
export function getdata(data) {
    // return $axios.get('/data/queryStoreList', params);
    return $axios.get('/api/bi/data_statistics/get_777_order_data', data);
}

// 下载 777 订单明细
export function export777OrderDetail(params) {
    return $axios.get('/api/bi/data_statistics/export_777_order_detail', params, 'blob');
}